import Kfit from 'integrations/Kfit';

export default params => Kfit.post(`/v1/fcm_authentications`, params);
